import { Chip } from "@material-ui/core";
import { Box, Grid, styled, Tooltip } from "@mui/material";
import { CurrencyDisplay, CurrencyNumberInput } from "components";
import { formatDate } from "utils";

const TableCellMultipleRow = ({
  list,
  itemKey,
  type,
  prefix,
  prefixKey,
  tooltipKey,
  suffix,
  onChange,
  startAdornment,
  endAdornment,
  disabled = false,
  subItemKey,
  subItemTooltipKey,
  subItemChild,
  rowHeight = 24,
  textAlign,
}) => {
  const totalSubItemCount = list?.reduce((acc, item) => {
    const count = Array.isArray(item?.[subItemChild])
      ? item[subItemChild].length
      : 1;
    return acc + count;
  }, 0);

  const getDefaultValue = value => (typeof value === "string" ? "-" : 0);

  return (
    <Grid container direction="column">
      {list?.length > 0 ? (
        (list || []).map((item, index) => (
          <Grid item key={index}>
            {list?.length > 1 && index > 0 && <CellBorder />}
            {Array.isArray(item?.[itemKey]) ? (
              <Grid container direction="column">
                {(item?.[itemKey] || [])?.map((subItem, idx) => (
                  <Grid item key={idx}>
                    {item?.[itemKey]?.length > 1 && idx > 0 && <CellBorder />}
                    <Tooltip
                      title={subItem?.[subItemTooltipKey]}
                      placement="bottom"
                    >
                      <Box
                        alignContent="center"
                        width="100%"
                        height={rowHeight}
                      >
                        {type === "number" ? (
                          <CurrencyDisplay
                            value={subItem?.[subItemKey] || 0}
                            decimalScale={
                              prefix && subItem?.[subItemKey] ? 2 : 0
                            }
                            prefix={
                              prefixKey
                                ? `${subItem?.[prefixKey] || ""}`
                                : prefix
                            }
                            suffix={suffix}
                            disabled={disabled}
                            textAlign={textAlign}
                          />
                        ) : type === "date" ? (
                          formatDate(subItem?.[subItemKey])
                        ) : type === "chip" ? (
                          <Chip
                            label={
                              `${prefix} ${subItem?.[subItemKey]} ${suffix}` ||
                              "-"
                            }
                            size="small"
                            variant="outlined"
                          />
                        ) : (
                          subItem?.[subItemKey] ||
                          getDefaultValue(subItem?.[subItemKey])
                        )}
                      </Box>
                    </Tooltip>
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Tooltip title={item?.[tooltipKey]} placement="bottom">
                <Box
                  alignContent="center"
                  width="100%"
                  minHeight={
                    Array.isArray(item?.[subItemChild]) &&
                    ((item[subItemChild].length || 1) / totalSubItemCount) *
                      (rowHeight * totalSubItemCount) +
                      (item[subItemChild].length > 1 ? 16 : 0)
                  }
                >
                  {type === "number" ? (
                    <CurrencyDisplay
                      value={item?.[itemKey] || 0}
                      decimalScale={prefix && item?.[itemKey] ? 2 : 0}
                      prefix={prefixKey ? `${item?.[prefixKey] || ""}` : prefix}
                      suffix={suffix}
                      disabled={disabled}
                      textAlign={textAlign}
                    />
                  ) : type === "date" ? (
                    formatDate(item?.[itemKey])
                  ) : type === "chip" ? (
                    <Chip
                      label={
                        `${prefix || ""}${item?.[itemKey]}${suffix || ""}` ||
                        "-"
                      }
                      size="small"
                      variant="outlined"
                    />
                  ) : type === "numberInput" ? (
                    <CurrencyNumberInput
                      value={item?.[itemKey]}
                      onChange={value => onChange({ value, item })}
                      startAdornment={startAdornment}
                      endAdornment={endAdornment}
                      disabled={disabled}
                    />
                  ) : (
                    item?.[itemKey] || getDefaultValue(item?.[itemKey])
                  )}
                </Box>
              </Tooltip>
            )}
          </Grid>
        ))
      ) : (
        <Grid
          item
          textAlign={textAlign ? textAlign : type === "number" && "right"}
        >
          {type === "number" ? (prefix || prefixKey ? "Rp0.00" : 0) : "-"}
        </Grid>
      )}
    </Grid>
  );
};

const CellBorder = styled(Box)({
  margin: "8px -16px",
  height: "1px",
  backgroundColor: "#e0e0e0",
});
export default TableCellMultipleRow;
